import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Panel } from 'rsuite';
import {
  Dropdown,
  Popover,
  Whisper,
  WhisperInstance,
  Stack,
  Badge,
  Avatar,
  IconButton,
  List,
  Button
} from 'rsuite';
import NoticeIcon from '@rsuite/icons/Notice';
import GearIcon from '@rsuite/icons/Gear';

const renderAdminSpeaker = ({ onClose, left, top, className }: any, ref) => {
  const handleSelect = eventKey => {
    onClose();
    console.log(eventKey);
  };
  
  return (

    <Popover ref={ref} className={className} style={{ left, top }} full>
      <Dropdown.Menu onSelect={handleSelect}>
        <Dropdown.Item panel style={{ padding: 10, width: 160 }}>
          <p>Signed in as</p>
          <strong>Administrator</strong>
        </Dropdown.Item>
        <Dropdown.Item divider />
        <Dropdown.Item>Settings</Dropdown.Item>
        <Link className='link' to='/'>
        <Dropdown.Item>Sign out</Dropdown.Item>
        </Link>
        {/* <Dropdown.Item
        
        <Dropdown.Item
          icon={<HelpOutlineIcon />}
          href="https://rsuitejs.com"
          target="_blank"
          as="a"
        >
          Help{' '}
        </Dropdown.Item> */}
      </Dropdown.Menu>
    </Popover>
   
  );
};

const renderAdminSpeakerr = ({ onClose, left, top, className }: any, ref) => {
  const handleSelect = eventKey => {
    onClose();
    console.log(eventKey);
  };
  
  return (
    <Popover ref={ref} className={className} style={{ left, top }} full>
      <Dropdown.Menu onSelect={handleSelect}>
      <Dropdown.Item panel style={{ padding: 10, width: 160 }}/>
        <Link className='link' to="/adduser"><Dropdown.Item>New User</Dropdown.Item></Link>
      <Link className='link' to="/companyMaster"><Dropdown.Item>Company</Dropdown.Item></Link>
      <Link className='link' to="/master"><Dropdown.Item>Masters</Dropdown.Item></Link>
      </Dropdown.Menu>
    </Popover>
  );
};

const renderNoticeSpeaker = ({ onClose, left, top, className }: any, ref) => {
  const notifications = [
    [
      '7 hours ago',
      'The charts of the dashboard have been fully upgraded and are more visually pleasing.'
    ],
    [
      '13 hours ago',
      'The function of virtualizing large lists has been added, and the style of the list can be customized as required.'
    ],
    ['2 days ago', 'Upgraded React 18 and Webpack 5.'],
    [
      '3 days ago',
      'Upgraded React Suite 5 to support TypeScript, which is more concise and efficient.'
    ]
  ];

  return ( 
    <Popover ref={ref} className={className} style={{ left, top, width: 300 }} title="Last updates">
      <List>
        {notifications.map((item, index) => {
          const [time, content] = item;
          return (
            <List.Item key={index}>
              <Stack spacing={4}>
                <Badge /> <span style={{ color: '#57606a' }}>{time}</span>
              </Stack>

              <p>{content}</p>
            </List.Item>
          );
        })}
      </List>
      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <Button onClick={onClose}>More notifications</Button>
      </div>
    </Popover>
    
  );
};


const Header = () => {
  const trigger = useRef<WhisperInstance>(null);
  let time = new Date().toLocaleTimeString();

  const [ctime, setCtime] = useState(time);

  const UpdateTime = () => {
    time = new Date().toLocaleTimeString();
    setCtime(time);
  };

  setInterval(UpdateTime, 1000);

  return (
    <>
    <div style={{height:'10vh'}}> 
    <Panel header={<h3 className="title" style={{'background':'#fff','paddingLeft':'15px', 'borderRadius':'8px','height':'47px'}}> 
      <Stack justifyContent='space-between'>
      <div className='time'><h5><b> {ctime} </b></h5></div>
      <Stack className="header" spacing={8} style={{height:'44px'}}>
      <Whisper placement="bottomEnd" trigger="click" ref={trigger} speaker={renderNoticeSpeaker}>
        <IconButton
          icon={
            <Badge content={5}>
              <NoticeIcon style={{ fontSize: 20 }} />
            </Badge>
          }
        />
      </Whisper>
      <Whisper placement="bottomEnd" trigger="click" ref={trigger} speaker={renderAdminSpeakerr}>
        <IconButton icon={<GearIcon spin style={{ fontSize: 20 }} />} />
      </Whisper>
      <Whisper placement="bottomEnd" trigger="click" ref={trigger} speaker={renderAdminSpeaker}>
        <Avatar
          size="md"
          circle
          src="https://avatars.githubusercontent.com/u/1203827"
          alt="@simonguo"
          style={{ marginTop: 19 }}
        />
      </Whisper>
    </Stack>
      </Stack>
      </h3>}>
    </Panel>
    </div>
    </>
  );
};

export default Header;
